import React, { useState } from 'react'
import moment from 'moment'
import { Card, DatePicker, Dropdown, Menu, message, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import { Typography } from '../../../../../../../core/components'
import { CardExtra, CardTitle } from './components'
import { handleEdit, onDeleteForecast } from './utils'
import { connect } from 'react-redux'
import { CommentOutlined } from '@ant-design/icons'
import forecast from 'modules/forecast'
import login from 'modules/login'
import configuration from 'modules/configuration'
import _ from 'lodash'
import { generateMessageError, sendUserDataToGTM } from 'modules/core/utils'
import { GENERAL } from 'modules/core/constants'
import PropTypes from 'prop-types'
import { useCommentData } from 'modules/core/customHooks'

import './ForecastCard.scss'

const ForecastCard = ({
  forecast,
  userCanCreate,
  onRefetch,
  deleteForecast,
  editForecastName,
  hasComment,
  setHasComment,
  loggedUser,
  setDataComments,
  comments,
  onRefetchComments,
  loading,
  createComment,
  removeNewComment,
}) => {
  const [editName, setEditName] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [deleteForecastId, setDeleteForecastId] = useState(null)
  const [dataEdit, setDataEdit] = useState({})
  const [viewComment, setViewComment] = useState(false)
  const [isCommentSaving, setIsCommentSaving] = useState(false)

  let history = useHistory()
  let { periodId } = useParams()
  const { t } = useTranslation()

  const key = window.location.pathname.replaceAll('/', '-')

  const commentData = useCommentData({ hasComment, key, id: forecast.id })

  const onCloseEdit = (value) => {
    setEditName(false)
    setIsSaving(false)
    setDataEdit({ ...dataEdit, name: value })
  }

  const onCloseDelete = () => {
    setDeleteForecastId(null)
    setIsSaving(false)
  }

  const handleCreate = ({ text, usersIds, idComment = null, setIsNewThread }) => {
    const dataa = {
      text,
      key: `${key}-card-${forecast.id}`,
      module: key,
      mentions: usersIds,
      ...(idComment && {
        parent: idComment,
      }),
    }
    setIsCommentSaving(true)
    createComment(dataa)
      .then(() =>
        onRefetchComments().then(() => {
          message.success(t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
          setIsCommentSaving(false)
          setIsNewThread(false)
        }),
      )
      .catch((error) => {
        message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL_MESSAGE'), 8)
        setIsCommentSaving(false)
        setIsNewThread(false)
      })
  }

  return (
    <Dropdown
      trigger={['contextMenu']}
      overlay={
        <Menu>
          {GENERAL.OPTION_COMMENT.map((el) => (
            <Menu.Item
              key={el.key}
              icon={<CommentOutlined />}
              onClick={() => {
                setViewComment(true)
                setHasComment({
                  type: 'card',
                  data: commentData,
                  key,
                  id: forecast.id,
                })
              }}
            >
              {t(el.label)}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Card
        className="card-forecast-initial-screen"
        title={
          <CardTitle
            loading={isSaving}
            defaultValue={forecast.name}
            editName={editName}
            onBlur={(e) =>
              handleEdit({
                value: e.target.value,
                dataEdit,
                setIsLoading: setIsSaving,
                editForecastName,
                onRefetch,
                onClose: () => onCloseEdit(e.target.value),
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(loggedUser, 'Forecast', 'Editar forecast', 'Edición'),
              })
            }
            onPressEnter={(e) =>
              handleEdit({
                value: e.target.value,
                dataEdit,
                setIsLoading: setIsSaving,
                editForecastName,
                onRefetch,
                onClose: () => onCloseEdit(e.target.value),
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(loggedUser, 'Forecast', 'Editar forecast', 'Edición'),
              })
            }
            title={forecast.name}
          />
        }
        headStyle={{ height: 56 }}
        bodyStyle={{ height: 126 }}
        extra={
          <CardExtra
            loading={isSaving}
            onConfirmPopConfirm={(e) => {
              e.stopPropagation()
              onDeleteForecast({
                setIsLoading: setIsSaving,
                deleteForecast: () => deleteForecast(deleteForecastId),
                onRefetch,
                onClose: onCloseDelete,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(loggedUser, 'Forecast', 'Eliminar forecast', 'Eliminación'),
              })
            }}
            onCancelPopConfirm={(e) => {
              e.stopPropagation()
              setDeleteForecastId(null)
            }}
            visiblePopConfirm={deleteForecastId === forecast.id}
            status={forecast.status}
            tooltiTitle={t('FIELD_CREATOR_INFO', { username: forecast.user })}
            onClickEdit={(e) => {
              e.domEvent.stopPropagation()
              setDeleteForecastId(forecast.id)
            }}
            disabled={!userCanCreate}
            onClickDelete={(e) => {
              e.domEvent.stopPropagation()
              setEditName(true)
              setDataEdit({ id: forecast.id, name: forecast.name })
            }}
            showComments={
              viewComment ||
              comments.filter((el) => el.key === `${key}-card-${forecast.id}` && !el.resolved)
                .length > 0
            }
            hasComment={
              !_.isEmpty(hasComment?.card)
                ? !_.isEmpty(hasComment?.card[key]) && hasComment?.card[key][forecast.id]
                : false
            }
            setHasComment={(visible) =>
              setHasComment({ type: 'card', data: visible, key, id: forecast.id })
            }
            setViewComment={setViewComment}
            loggedUser={loggedUser}
            setDataComments={setDataComments}
            comments={comments.filter(
              (el) => (el.key === `${key}-card-${forecast.id}` && !el.resolved) || !el.text,
            )}
            onRefetchComments={onRefetchComments}
            loadingComments={loading || isCommentSaving}
            onCommentCreate={(text, usersIds, idComment, setIsNewThread) =>
              handleCreate({ text, usersIds, idComment, setIsNewThread })
            }
            onCleanHasComment={() => {
              setHasComment({ type: 'card', data: false, key, id: forecast.id })
              setViewComment(false)
            }}
            removeNewComment={removeNewComment}
            onClickActivity={(e) => {
              e.domEvent.stopPropagation()
              history.push(
                `/forecast/${periodId}/${forecast.id}/actividad?type=forecast&module=forecast`,
              )
            }}
          />
        }
        onClick={() => history.push(`/forecast/${periodId}/${forecast.id}`)}
        onMouseDown={(e) => {
          if (e.button === 1) {
            e.stopPropagation()
            window.open(`/forecast/${periodId}/${forecast.id}`, '_blank')
          }
        }}
      >
        <Space direction="vertical">
          <Typography.Body level={2}>{t('FORECAST_CUT_DATE_FIELD')}</Typography.Body>
          <DatePicker
            style={{ width: 266 }}
            value={moment(forecast.year_month, 'YYYY-MM-DD')}
            disabled={true}
            format="MMMM YYYY"
          />
        </Space>
      </Card>
    </Dropdown>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
  hasComment: configuration.selectors.getHasComment(state),
})

const mapDispatchToProps = {
  deleteForecast: forecast.actions.deleteForecast,
  editForecastName: forecast.actions.editForecastName,
  setHasComment: configuration.actions.setHasComment,
  createComment: configuration.actions.createComment,
  removeNewComment: configuration.actions.removeNewComment,
}

ForecastCard.propTypes = {
  editForecastName: PropTypes.func,
  hasComment: PropTypes.shape({
    card: PropTypes.object,
  }),
  setHasComment: PropTypes.func,
  loggedUser: PropTypes.object,
  setDataComments: PropTypes.func,
  comments: PropTypes.array,
  onRefetchComments: PropTypes.func,
  loading: PropTypes.bool,
  createComment: PropTypes.func,
  removeNewComment: PropTypes.func,
  forecast: PropTypes.shape({
    id: PropTypes.any,
    user: PropTypes.string,
    name: PropTypes.string,
    year_month: PropTypes.string,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ForecastCard)
